module.exports = __webpack_public_path__ + "media/images/edit_profile_avatar-13b9cad5e2344815893e8d734cba8396.svg";